import { Fragment } from "react/jsx-runtime";


export default function CCOtherAssessmentSummary(){

    return (<Fragment>
        <span className="pp-font-size-smallest">ABPN's ABCC pathway is not an option for this certification. <br />Please see the <a target="_BLANK" href="https://www.abpn.org/maintain-certification/taking-a-moc-exam/subspecialty-moc-exams/">ABPN Website</a> for more details.</span>
    </Fragment>)
}